"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserProfileServiceServer = exports.UserProfileServiceDispatcher = exports.UserProfileServiceClient = void 0;
var RecoveryCodes_1 = require("./RecoveryCodes");
var SetupMfaRequest_1 = require("./SetupMfaRequest");
var RequestedMfaSetup_1 = require("./RequestedMfaSetup");
var UserApiKey_1 = require("./UserApiKey");
var UserApiKeys_1 = require("./UserApiKeys");
var ConfirmMfaSetup_1 = require("./ConfirmMfaSetup");
var AccessLevel_1 = require("./AccessLevel");
var UserPublic_1 = require("./UserPublic");
var MfaRequest_1 = require("./MfaRequest");
var UserUpdateRequest_1 = require("./UserUpdateRequest");
var ConfirmMfa_1 = require("./ConfirmMfa");
var services_shared_1 = require("@playq/services-shared");
var UserSettings_1 = require("./UserSettings");
var irt_1 = require("@playq/irt");
var InRetrieve = (function () {
    function InRetrieve(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
    }
    InRetrieve.prototype.serialize = function () {
        return {};
    };
    return InRetrieve;
}());
var OutRetrieveHelpers = (function () {
    function OutRetrieveHelpers() {
    }
    OutRetrieveHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutRetrieveHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new UserPublic_1.UserPublic(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutRetrieveHelpers;
}());
var InUpdate = (function () {
    function InUpdate(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.request = new UserUpdateRequest_1.UserUpdateRequest(data.request);
    }
    Object.defineProperty(InUpdate.prototype, "request", {
        get: function () {
            return this._request;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field request is not optional');
            }
            this._request = value;
        },
        enumerable: false,
        configurable: true
    });
    InUpdate.prototype.serialize = function () {
        return {
            request: this.request.serialize()
        };
    };
    return InUpdate;
}());
var OutUpdateHelpers = (function () {
    function OutUpdateHelpers() {
    }
    OutUpdateHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutUpdateHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutUpdateHelpers;
}());
var InRequestMfaSetup = (function () {
    function InRequestMfaSetup(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.mfa = SetupMfaRequest_1.SetupMfaRequestHelpers.deserialize(data.mfa);
    }
    Object.defineProperty(InRequestMfaSetup.prototype, "mfa", {
        get: function () {
            return this._mfa;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field mfa is not optional');
            }
            this._mfa = value;
        },
        enumerable: false,
        configurable: true
    });
    InRequestMfaSetup.prototype.serialize = function () {
        return {
            mfa: SetupMfaRequest_1.SetupMfaRequestHelpers.serialize(this.mfa)
        };
    };
    return InRequestMfaSetup;
}());
var OutRequestMfaSetupHelpers = (function () {
    function OutRequestMfaSetupHelpers() {
    }
    OutRequestMfaSetupHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': RequestedMfaSetup_1.RequestedMfaSetupHelpers.serialize(either.value)
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutRequestMfaSetupHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(RequestedMfaSetup_1.RequestedMfaSetupHelpers.deserialize(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutRequestMfaSetupHelpers;
}());
var InConfirmMfaSetup = (function () {
    function InConfirmMfaSetup(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.mfa = ConfirmMfaSetup_1.ConfirmMfaSetupHelpers.deserialize(data.mfa);
    }
    Object.defineProperty(InConfirmMfaSetup.prototype, "mfa", {
        get: function () {
            return this._mfa;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field mfa is not optional');
            }
            this._mfa = value;
        },
        enumerable: false,
        configurable: true
    });
    InConfirmMfaSetup.prototype.serialize = function () {
        return {
            mfa: ConfirmMfaSetup_1.ConfirmMfaSetupHelpers.serialize(this.mfa)
        };
    };
    return InConfirmMfaSetup;
}());
var OutConfirmMfaSetupHelpers = (function () {
    function OutConfirmMfaSetupHelpers() {
    }
    OutConfirmMfaSetupHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutConfirmMfaSetupHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new RecoveryCodes_1.RecoveryCodes(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutConfirmMfaSetupHelpers;
}());
var InRequestCodesReset = (function () {
    function InRequestCodesReset(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
    }
    InRequestCodesReset.prototype.serialize = function () {
        return {};
    };
    return InRequestCodesReset;
}());
var OutRequestCodesResetHelpers = (function () {
    function OutRequestCodesResetHelpers() {
    }
    OutRequestCodesResetHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': MfaRequest_1.MfaRequestHelpers.serialize(either.value)
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutRequestCodesResetHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(MfaRequest_1.MfaRequestHelpers.deserialize(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutRequestCodesResetHelpers;
}());
var InConfirmCodesReset = (function () {
    function InConfirmCodesReset(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.mfa = ConfirmMfa_1.ConfirmMfaHelpers.deserialize(data.mfa);
    }
    Object.defineProperty(InConfirmCodesReset.prototype, "mfa", {
        get: function () {
            return this._mfa;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field mfa is not optional');
            }
            this._mfa = value;
        },
        enumerable: false,
        configurable: true
    });
    InConfirmCodesReset.prototype.serialize = function () {
        return {
            mfa: ConfirmMfa_1.ConfirmMfaHelpers.serialize(this.mfa)
        };
    };
    return InConfirmCodesReset;
}());
var OutConfirmCodesResetHelpers = (function () {
    function OutConfirmCodesResetHelpers() {
    }
    OutConfirmCodesResetHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutConfirmCodesResetHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new RecoveryCodes_1.RecoveryCodes(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutConfirmCodesResetHelpers;
}());
var InDisableMfa = (function () {
    function InDisableMfa(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.recoveryCode = data.recoveryCode;
    }
    Object.defineProperty(InDisableMfa.prototype, "recoveryCode", {
        get: function () {
            return this._recoveryCode;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field recoveryCode is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field recoveryCode expects type string, got ' + value);
            }
            this._recoveryCode = value;
        },
        enumerable: false,
        configurable: true
    });
    InDisableMfa.prototype.serialize = function () {
        return {
            recoveryCode: this.recoveryCode
        };
    };
    return InDisableMfa;
}());
var OutDisableMfaHelpers = (function () {
    function OutDisableMfaHelpers() {
    }
    OutDisableMfaHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutDisableMfaHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutDisableMfaHelpers;
}());
var InCreateApiKey = (function () {
    function InCreateApiKey(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.name = data.name;
        this.accessLevel = AccessLevel_1.AccessLevel[data.accessLevel];
    }
    Object.defineProperty(InCreateApiKey.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field name is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field name expects type string, got ' + value);
            }
            this._name = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InCreateApiKey.prototype, "accessLevel", {
        get: function () {
            return this._accessLevel;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field accessLevel is not optional');
            }
            this._accessLevel = value;
        },
        enumerable: false,
        configurable: true
    });
    InCreateApiKey.prototype.serialize = function () {
        return {
            name: this.name,
            accessLevel: AccessLevel_1.AccessLevel[this.accessLevel]
        };
    };
    return InCreateApiKey;
}());
var OutCreateApiKeyHelpers = (function () {
    function OutCreateApiKeyHelpers() {
    }
    OutCreateApiKeyHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutCreateApiKeyHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new UserApiKey_1.UserApiKey(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutCreateApiKeyHelpers;
}());
var InGetApiKeys = (function () {
    function InGetApiKeys(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
    }
    InGetApiKeys.prototype.serialize = function () {
        return {};
    };
    return InGetApiKeys;
}());
var OutGetApiKeysHelpers = (function () {
    function OutGetApiKeysHelpers() {
    }
    OutGetApiKeysHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutGetApiKeysHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new UserApiKeys_1.UserApiKeys(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutGetApiKeysHelpers;
}());
var InDeleteApiKey = (function () {
    function InDeleteApiKey(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = data.id;
    }
    Object.defineProperty(InDeleteApiKey.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    InDeleteApiKey.prototype.serialize = function () {
        return {
            id: this.id
        };
    };
    return InDeleteApiKey;
}());
var OutDeleteApiKeyHelpers = (function () {
    function OutDeleteApiKeyHelpers() {
    }
    OutDeleteApiKeyHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutDeleteApiKeyHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutDeleteApiKeyHelpers;
}());
var InRetrieveSettings = (function () {
    function InRetrieveSettings(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
    }
    InRetrieveSettings.prototype.serialize = function () {
        return {};
    };
    return InRetrieveSettings;
}());
var OutRetrieveSettingsHelpers = (function () {
    function OutRetrieveSettingsHelpers() {
    }
    OutRetrieveSettingsHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': typeof either.value !== 'undefined' ? either.value.serialize() : undefined
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutRetrieveSettingsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(typeof content !== 'undefined' ? new UserSettings_1.UserSettings(content) : undefined);
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutRetrieveSettingsHelpers;
}());
var InUpsertSettings = (function () {
    function InUpsertSettings(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.settings = new UserSettings_1.UserSettings(data.settings);
    }
    Object.defineProperty(InUpsertSettings.prototype, "settings", {
        get: function () {
            return this._settings;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field settings is not optional');
            }
            this._settings = value;
        },
        enumerable: false,
        configurable: true
    });
    InUpsertSettings.prototype.serialize = function () {
        return {
            settings: this.settings.serialize()
        };
    };
    return InUpsertSettings;
}());
var OutUpsertSettingsHelpers = (function () {
    function OutUpsertSettingsHelpers() {
    }
    OutUpsertSettingsHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutUpsertSettingsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutUpsertSettingsHelpers;
}());
var UserProfileServiceClient = (function () {
    function UserProfileServiceClient(transport) {
        this._transport = transport;
    }
    UserProfileServiceClient.prototype.getPackageName = function () { return UserProfileServiceClient.PackageName; };
    UserProfileServiceClient.prototype.getClassName = function () { return UserProfileServiceClient.ClassName; };
    UserProfileServiceClient.prototype.getFullClassName = function () { return UserProfileServiceClient.FullClassName; };
    UserProfileServiceClient.prototype.send = function (method, data, inputType, outputType) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._transport.send(UserProfileServiceClient.ClassName, method, data)
                .then(function (data) {
                try {
                    var output = new outputType(data);
                    resolve(output);
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    UserProfileServiceClient.prototype.retrieve = function () {
        var _this = this;
        var __data = new InRetrieve();
        return new Promise(function (resolve, reject) {
            _this._transport.send(UserProfileServiceClient.ClassName, 'retrieve', __data)
                .then(function (data) {
                try {
                    resolve(OutRetrieveHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    UserProfileServiceClient.prototype.update = function (request) {
        var _this = this;
        var __data = new InUpdate();
        __data.request = request;
        return new Promise(function (resolve, reject) {
            _this._transport.send(UserProfileServiceClient.ClassName, 'update', __data)
                .then(function (data) {
                try {
                    resolve(OutUpdateHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    UserProfileServiceClient.prototype.requestMfaSetup = function (mfa) {
        var _this = this;
        var __data = new InRequestMfaSetup();
        __data.mfa = mfa;
        return new Promise(function (resolve, reject) {
            _this._transport.send(UserProfileServiceClient.ClassName, 'requestMfaSetup', __data)
                .then(function (data) {
                try {
                    resolve(OutRequestMfaSetupHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    UserProfileServiceClient.prototype.confirmMfaSetup = function (mfa) {
        var _this = this;
        var __data = new InConfirmMfaSetup();
        __data.mfa = mfa;
        return new Promise(function (resolve, reject) {
            _this._transport.send(UserProfileServiceClient.ClassName, 'confirmMfaSetup', __data)
                .then(function (data) {
                try {
                    resolve(OutConfirmMfaSetupHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    UserProfileServiceClient.prototype.requestCodesReset = function () {
        var _this = this;
        var __data = new InRequestCodesReset();
        return new Promise(function (resolve, reject) {
            _this._transport.send(UserProfileServiceClient.ClassName, 'requestCodesReset', __data)
                .then(function (data) {
                try {
                    resolve(OutRequestCodesResetHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    UserProfileServiceClient.prototype.confirmCodesReset = function (mfa) {
        var _this = this;
        var __data = new InConfirmCodesReset();
        __data.mfa = mfa;
        return new Promise(function (resolve, reject) {
            _this._transport.send(UserProfileServiceClient.ClassName, 'confirmCodesReset', __data)
                .then(function (data) {
                try {
                    resolve(OutConfirmCodesResetHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    UserProfileServiceClient.prototype.disableMfa = function (recoveryCode) {
        var _this = this;
        var __data = new InDisableMfa();
        __data.recoveryCode = recoveryCode;
        return new Promise(function (resolve, reject) {
            _this._transport.send(UserProfileServiceClient.ClassName, 'disableMfa', __data)
                .then(function (data) {
                try {
                    resolve(OutDisableMfaHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    UserProfileServiceClient.prototype.createApiKey = function (name, accessLevel) {
        var _this = this;
        var __data = new InCreateApiKey();
        __data.name = name;
        __data.accessLevel = accessLevel;
        return new Promise(function (resolve, reject) {
            _this._transport.send(UserProfileServiceClient.ClassName, 'createApiKey', __data)
                .then(function (data) {
                try {
                    resolve(OutCreateApiKeyHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    UserProfileServiceClient.prototype.getApiKeys = function () {
        var _this = this;
        var __data = new InGetApiKeys();
        return new Promise(function (resolve, reject) {
            _this._transport.send(UserProfileServiceClient.ClassName, 'getApiKeys', __data)
                .then(function (data) {
                try {
                    resolve(OutGetApiKeysHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    UserProfileServiceClient.prototype.deleteApiKey = function (id) {
        var _this = this;
        var __data = new InDeleteApiKey();
        __data.id = id;
        return new Promise(function (resolve, reject) {
            _this._transport.send(UserProfileServiceClient.ClassName, 'deleteApiKey', __data)
                .then(function (data) {
                try {
                    resolve(OutDeleteApiKeyHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    UserProfileServiceClient.prototype.retrieveSettings = function () {
        var _this = this;
        var __data = new InRetrieveSettings();
        return new Promise(function (resolve, reject) {
            _this._transport.send(UserProfileServiceClient.ClassName, 'retrieveSettings', __data)
                .then(function (data) {
                try {
                    resolve(OutRetrieveSettingsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    UserProfileServiceClient.prototype.upsertSettings = function (settings) {
        var _this = this;
        var __data = new InUpsertSettings();
        __data.settings = settings;
        return new Promise(function (resolve, reject) {
            _this._transport.send(UserProfileServiceClient.ClassName, 'upsertSettings', __data)
                .then(function (data) {
                try {
                    resolve(OutUpsertSettingsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    UserProfileServiceClient.PackageName = 'net.playq.octopus2.auth';
    UserProfileServiceClient.ClassName = 'UserProfileService';
    UserProfileServiceClient.FullClassName = 'net.playq.octopus2.auth.UserProfileService';
    return UserProfileServiceClient;
}());
exports.UserProfileServiceClient = UserProfileServiceClient;
var UserProfileServiceDispatcher = (function () {
    function UserProfileServiceDispatcher(marshaller, server) {
        this.marshaller = marshaller;
        this.server = server;
    }
    UserProfileServiceDispatcher.prototype.getSupportedService = function () {
        return 'UserProfileService';
    };
    UserProfileServiceDispatcher.prototype.getSupportedMethods = function () {
        return UserProfileServiceDispatcher.methods;
    };
    UserProfileServiceDispatcher.prototype.dispatch = function (context, method, data) {
        var _this = this;
        switch (method) {
            case "retrieve": {
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.retrieve(context)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutRetrieveHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "update": {
                var obj_1 = new InUpdate(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.update(context, obj_1.request)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUpdateHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "requestMfaSetup": {
                var obj_2 = new InRequestMfaSetup(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.requestMfaSetup(context, obj_2.mfa)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutRequestMfaSetupHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "confirmMfaSetup": {
                var obj_3 = new InConfirmMfaSetup(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.confirmMfaSetup(context, obj_3.mfa)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutConfirmMfaSetupHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "requestCodesReset": {
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.requestCodesReset(context)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutRequestCodesResetHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "confirmCodesReset": {
                var obj_4 = new InConfirmCodesReset(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.confirmCodesReset(context, obj_4.mfa)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutConfirmCodesResetHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "disableMfa": {
                var obj_5 = new InDisableMfa(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.disableMfa(context, obj_5.recoveryCode)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutDisableMfaHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "createApiKey": {
                var obj_6 = new InCreateApiKey(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.createApiKey(context, obj_6.name, obj_6.accessLevel)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutCreateApiKeyHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "getApiKeys": {
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.getApiKeys(context)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutGetApiKeysHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "deleteApiKey": {
                var obj_7 = new InDeleteApiKey(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.deleteApiKey(context, obj_7.id)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutDeleteApiKeyHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "retrieveSettings": {
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.retrieveSettings(context)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutRetrieveSettingsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "upsertSettings": {
                var obj_8 = new InUpsertSettings(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.upsertSettings(context, obj_8.settings)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUpsertSettingsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            default:
                throw new Error("Method ".concat(method, " is not supported by UserProfileServiceDispatcher."));
        }
    };
    UserProfileServiceDispatcher.methods = [
        "retrieve",
        "update",
        "requestMfaSetup",
        "confirmMfaSetup",
        "requestCodesReset",
        "confirmCodesReset",
        "disableMfa",
        "createApiKey",
        "getApiKeys",
        "deleteApiKey",
        "retrieveSettings",
        "upsertSettings"
    ];
    return UserProfileServiceDispatcher;
}());
exports.UserProfileServiceDispatcher = UserProfileServiceDispatcher;
var UserProfileServiceServer = (function (_super) {
    __extends(UserProfileServiceServer, _super);
    function UserProfileServiceServer(marshaller) {
        var _this = _super.call(this, marshaller, null) || this;
        _this.server = _this;
        return _this;
    }
    UserProfileServiceServer.prototype.retrieve = function (context) {
        throw new Error('Not implemented.');
    };
    UserProfileServiceServer.prototype.update = function (context, request) {
        throw new Error('Not implemented.');
    };
    UserProfileServiceServer.prototype.requestMfaSetup = function (context, mfa) {
        throw new Error('Not implemented.');
    };
    UserProfileServiceServer.prototype.confirmMfaSetup = function (context, mfa) {
        throw new Error('Not implemented.');
    };
    UserProfileServiceServer.prototype.requestCodesReset = function (context) {
        throw new Error('Not implemented.');
    };
    UserProfileServiceServer.prototype.confirmCodesReset = function (context, mfa) {
        throw new Error('Not implemented.');
    };
    UserProfileServiceServer.prototype.disableMfa = function (context, recoveryCode) {
        throw new Error('Not implemented.');
    };
    UserProfileServiceServer.prototype.createApiKey = function (context, name, accessLevel) {
        throw new Error('Not implemented.');
    };
    UserProfileServiceServer.prototype.getApiKeys = function (context) {
        throw new Error('Not implemented.');
    };
    UserProfileServiceServer.prototype.deleteApiKey = function (context, id) {
        throw new Error('Not implemented.');
    };
    UserProfileServiceServer.prototype.retrieveSettings = function (context) {
        throw new Error('Not implemented.');
    };
    UserProfileServiceServer.prototype.upsertSettings = function (context, settings) {
        throw new Error('Not implemented.');
    };
    return UserProfileServiceServer;
}(UserProfileServiceDispatcher));
exports.UserProfileServiceServer = UserProfileServiceServer;
//# sourceMappingURL=UserProfileService.js.map